(ns storrito.editor.emoji-slider-sticker
  (:require [storrito.editor.poll-v2-sticker :as poll-v2-sticker]
            [storrito.editor.sticker-util :as sticker-util]
            [clojure.string :as str]))

;; Concept:
;;
;; Creates a FabricJS object that looks like an Instagram Emoji Slider
;; sticker.

;; The geometry of the sticker in the pixels of a 1080x1920 story. The
;; dialog preview (`ui.sticker-dialogs.emoji-slider`) scales the same
;; values down, so that the question wraps there like on the canvas.

(def panel-width
  (* 0.7777778 1050))

(def min-panel-height
  "The height of the panel without a question: the slider sits in the
   middle of it."
  (* 0.1359375 1920))

(def panel-radius
  26)

(def question-width
  (- panel-width 178))

(def question-top
  85)

(def question-font-size
  58)

(def question-line-height
  "FabricJS draws a line `fontSize * lineHeight (1.16) * _fontSizeMult
   (1.13)` high."
  (* 1.16 1.13))

(def question-max-lines
  6)

(def question-slider-gap
  "Between the bottom of the question and the slider area, which is
   `min-panel-height` high."
  (* 0.0328125 1920))

(def slider-half-width
  331)

(def slider-height
  23)

(def slider-radius
  11)

(def slider-emoji-size
  "The emoji is a FabricJS text in the default font size 40, scaled by
   two."
  80)

(defn slider-sticker [params]
  ;; Bugfix for wrong text bounding boxes
  ;; Due to wrong calculated char width in cache, the cache needs to be cleared
  ;; Found at: https://github.com/kangax/fabric.js/issues/2612
  (js/fabric.util.clearFabricFontCache)
  (let [background-color (:background-color params)
        text-color (:text-color params)
        slider-color (if (= background-color "#ffffff")
                       "#b604b0"
                       text-color)
        shadow #js{:color "rgba(0, 0, 0, 0.5)",
                   :blur 5,
                   :offsetX 3,
                   :offsetY 3,
                   :affectStroke false}
        ;; Wraps at spaces like Instagram, a word is only broken when
        ;; it is wider than the question by itself:
        question-object (poll-v2-sticker/fit-lines-textbox
                          (:question params)
                          {:fill text-color
                           :top question-top
                           :originX "center"
                           :originY "top"
                           :width question-width
                           :fontSize question-font-size
                           :fontFamily "Roboto"
                           :textAlign "center"}
                          question-max-lines)
        top-offset (if-not (str/blank? (:question params))
                     (+ (.-height question-object)
                        question-slider-gap)
                     0)
        panel-object (js/fabric.Rect. #js{:fill background-color
                                          :width panel-width
                                          :rx panel-radius
                                          :ry panel-radius
                                          :height (+ min-panel-height
                                                     top-offset)
                                          :originX "center"
                                          :originY "top"
                                          :shadow shadow})
        slider-highlight (js/fabric.Rect. #js{:fill slider-color
                                              :width slider-half-width
                                              :height slider-height
                                              :rx slider-radius
                                              :originX "right"
                                              :originY "center"})
        slider-shadow (js/fabric.Rect. #js{:fill (sticker-util/shadow-color background-color)
                                           :width slider-half-width
                                           :height slider-height
                                           :rx slider-radius
                                           :originX "left"
                                           :originY "center"})
        emoji-image (js/fabric.Text. (:emoji params)
                                      #js{:originX "center"
                                          :originY "center"
                                          :scaleX 2
                                          :scaleY 2})
        slider-group (js/fabric.Group. (into-array [slider-highlight slider-shadow emoji-image])
                                       #js{:originY "center"
                                           :top (+ (/ min-panel-height 2.0) top-offset)})]
    (js/fabric.Group. (into-array [panel-object question-object slider-group])
                      #js{:id "slider-sticker"
                          :lockScalingFlip true
                          :max-scale 1.3
                          :min-scale 0.3
                          :slider #js{:question (.-text question-object)
                                      :background_color background-color
                                      :text_color text-color
                                      :emoji (:emoji params)}
                          :top (or (:top params) 10)
                          :left (or (:left params) 10)
                          :angle (or (:angle params) 0.0)
                          :scaleY (or (:scaleX params) 1.0)
                          :scaleX (or (:scaleY params) 1.0)})))
